import * as Sentry from "@sentry/react";
import { graphql } from "./wp.api.service";
import { loader } from "graphql.macro";

import { generateRegistrationCloseTime, getUTCTime } from "../helpers/event";

// eslint-disable-next-line no-unused-vars
const gqlQuery = loader("../queries/courseQuery.gql");

export const transformSeries = ({ node }) => ({
	...node,
	courses: node.courses.edges.map(({ node: course }) => ({
		...course,
		...course.courseTiming,
		end: getUTCTime(`${course.courseTiming.coursedate}T${course.courseTiming.endtime}`),
		location: course.location?.node,
		registrationClose: course.courseTiming?.registrationclose
			? getUTCTime(course.courseTiming.registrationclose)
			: generateRegistrationCloseTime(course),
		registrationOpen: course.courseTiming?.registrationopen
			? getUTCTime(course.courseTiming.registrationopen)
			: null,
		series: {
			id: node.id,
			title: node.title
		},
		start: getUTCTime(`${course.date}`)
	}))
});

export const transformRecurringCourses = ({ node }, currentCourse = []) => ({
	...node,
	courses: node.courses.edges.map(({ node: course }) => ({
		...course,
		...course.courseTiming,
		end: getUTCTime(`${course.courseTiming.coursedate}T${course.courseTiming.endtime}`),
		location: course.location?.node,
		registrationClose: course.courseTiming?.registrationclose
			? getUTCTime(course.courseTiming.registrationclose)
			: generateRegistrationCloseTime(course),
		registrationOpen: course.courseTiming?.registrationopen
			? getUTCTime(course.courseTiming.registrationopen)
			: null,
		start: getUTCTime(`${course.date}`)
	})).filter(({ id }) => id !== currentCourse?.id)
});

const transformCourse = (course) => ({
	...course,
	...course.courseInfo,
	...course.courseTiming,
	date: getUTCTime(`${course.courseTiming.coursedate}T${course.courseTiming.starttime}`),
	end: getUTCTime(`${course.courseTiming.coursedate}T${course.courseTiming.endtime}`),
	facilitator: course.facilitator.edges ? course.facilitator.edges.map(({ node }) => node) : null,
	facilitatorId: course.facilitator.edges ? course.facilitator.edges.map(({ node }) => parseInt(node.id, 10)) : null,
	languages: course.languages.edges.map(({ node }) => node.name),
	location: course.location?.node,
	recurringClasses: course.recurringClasses.edges?.length ? transformRecurringCourses(course.recurringClasses.edges[0], course) : null,
	registrationClose: course.courseTiming?.registrationclose
		? getUTCTime(course.courseTiming.registrationclose)
		: generateRegistrationCloseTime(course),
	registrationOpen: course.courseTiming?.registrationopen ? getUTCTime(course.courseTiming.registrationopen) : null,
	series: course.series.edges?.length ? transformSeries(course.series.edges[0]) : null,
	start: getUTCTime(`${course.courseTiming.coursedate}T${course.courseTiming.starttime}`),
	type: course.courseTypes.edges.map(({ node: type }) => type).map(({ slug }) => slug)
});

export const getCourse = (useQuery, courseId, options) => useQuery(
	["course", courseId],
	() => graphql({
		cacheId: `persisted_course_${courseId}`,
		operationName: "SingleCourseQuery",
		query: gqlQuery.loc.source.body,
		variables: { courseId: parseInt(courseId, 10) }
	}, true, { cacheId: `persisted_course_${courseId}` }).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}
			let course = {};

			try {
				course = transformCourse(data.data.courseBy);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
				Sentry.captureException(error);
			}

			return course;
		}),
	{
		staleTime: 10 * 60 * 1000,
		useErrorBoundary: true,
		...options
	}
);

